import React from 'react';

const STATUS_COLORS = {
  new: 'primary',
  contacted: 'warning',
  in_progress: 'info',
  won: 'success',
  lost: 'danger',
  open: 'success',
  closed: 'secondary',
  applied: 'primary',
  screening: 'warning',
  interview: 'info',
  selected: 'success',
  rejected: 'danger',
  initiated: 'primary',
  under_process: 'warning',
  onboarded: 'success',
  onhold: 'secondary',
  active: 'success',
  on_hold: 'warning',
  completed: 'success',
  todo: 'secondary',
  blocked: 'danger',
  low: 'secondary',
  medium: 'info',
  high: 'danger'
};

export const getStatusColor = (status) => STATUS_COLORS[status] || 'secondary';

const StatusBadge = ({ status }) => {
  const color = getStatusColor(status);
  return (
    <span className={`badge bg-${color}`}>
      {status.replace(/_/g, ' ')}
    </span>
  );
};

export default StatusBadge;
